export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref11251.fb45fec1.jpg";